import { Directive, Host, OnInit, Optional } from '@angular/core';
import { SidebarComponent } from './sidebar.component';

/**
 * Registra los dashboards gerenciales como submódulos independientes.
 * Dashboard RRHH conserva sus cuatro vistas y Dashboard Productos mantiene
 * sus propias vistas de análisis de productos.
 */
@Directive({
  standalone: false,
  selector: 'app-sidebar',
})
export class SidebarDashboardMenuDirective implements OnInit {
  private readonly dashboardPermission =
    'recursos-humanos/contratacion/dashboard';
  private readonly supplyDashboardPermission =
    'recursos-humanos/contratacion/dashboard/abastecimiento-gerencial';

  constructor(
    @Host() @Optional() private readonly sidebar: SidebarComponent | null,
  ) {}

  ngOnInit(): void {
    if (!this.sidebar) return;

    const component = this.sidebar as any;
    const completeMenu = component.menuCompleto as any[] | undefined;
    if (!Array.isArray(completeMenu)) return;

    if (!completeMenu.some((group) => group?.clave === 'dashboard')) {
      const dashboardGroup = {
        categoria: 'Dashboard',
        clave: 'dashboard',
        items: [
          {
            tipo: 'subgrupo',
            nombre: 'Dashboard RRHH',
            clave: 'dashboard-rrhh',
            items: [
              {
                nombre: 'Análisis temporal',
                ruta: '/recursos-humanos/contratacion/dashboard/temporal',
                permiso: this.dashboardPermission,
              },
              {
                nombre: 'Cargos',
                ruta: '/recursos-humanos/contratacion/dashboard/cargos',
                permiso: this.dashboardPermission,
              },
              {
                nombre: 'Proyectos',
                ruta: '/recursos-humanos/contratacion/dashboard/proyectos',
                permiso: this.dashboardPermission,
              },
              {
                nombre: 'Impacto mensual',
                ruta: '/recursos-humanos/contratacion/dashboard/impacto-mensual',
                permiso: this.dashboardPermission,
              },
              {
                nombre: 'Capacidad reclutamiento',
                ruta: '/recursos-humanos/contratacion/dashboard/capacidad-reclutamiento',
                permiso: this.dashboardPermission,
              },
            ],
          },
          {
            tipo: 'subgrupo',
            nombre: 'Dashboard Productos',
            clave: 'dashboard-productos',
            items: [
              {
                nombre: 'Abastecimiento',
                ruta: '/productos/ingreso-rq/filtrado-bodega/dashboard-productos/abastecimiento',
                permiso: this.supplyDashboardPermission,
              },
            ],
          },
        ],
      };

      const taskListIndex = completeMenu.findIndex(
        (group) => group?.clave === 'tasklist',
      );
      completeMenu.splice(
        taskListIndex >= 0 ? taskListIndex + 1 : 0,
        0,
        dashboardGroup,
      );
    }

    if (typeof component.filtrarMenuPorPermisos === 'function') {
      component.filtrarMenuPorPermisos();
    }
  }
}
